export default "__VITE_ASSET__19d7ee20__"